export default {
  apiKey: process.env.REACT_APP_API_KEY || 'setAKeyInEnvPlease',
  apiUrl: process.env.REACT_APP_BIRTHDAY_API || 'http://localhost:8848',
  birthdayCount: process.env.REACT_APP_BIRTHDAY_COUNT || 9
};
